export default __webpack_public_path__ + "static/media/congratulations.af60de3c.png";